import { AxiosError, AxiosResponse } from "axios";
import { NavigateFunction } from "react-router-dom";
import { createApi } from "../../../utils/createApi";
import { universalAPIErrorHandler } from "../../../utils/universalAPIErrorHandler";
import { VlmCaseRow } from "./vlmCaseRegistry";

type VlmCaseListResponse = VlmCaseRow[] | { results: VlmCaseRow[] };

const normalizeVlmCaseList = (data: VlmCaseListResponse): VlmCaseRow[] => {
  if (Array.isArray(data)) {
    return data;
  }
  return data.results ?? [];
};

export const getVlmCases = (
  modalityId: number,
  navigate: NavigateFunction
): Promise<VlmCaseRow[]> => {
  const AxiosUI = createApi("");

  const retryFunction = () => getVlmCases(modalityId, navigate);

  return AxiosUI.get(`/vlm_case/?modality=${modalityId}`)
    .then((response: AxiosResponse<VlmCaseListResponse>) =>
      normalizeVlmCaseList(response.data)
    )
    .catch((reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
      return [];
    });
};

export const getAllVlmCases = (
  navigate: NavigateFunction
): Promise<VlmCaseRow[]> => {
  const AxiosUI = createApi("");

  const retryFunction = () => getAllVlmCases(navigate);

  return AxiosUI.get("/vlm_case/")
    .then((response: AxiosResponse<VlmCaseListResponse>) =>
      normalizeVlmCaseList(response.data)
    )
    .catch((reason: AxiosError) => {
      universalAPIErrorHandler(reason, navigate, retryFunction, () => {});
      return [];
    });
};
